import { Box, Button, Flex, Image, Link, Text } from "@chakra-ui/react";
import React from "react";
import { Icons } from "../../Assets/icons";

type Props = {
  handleCloseModal: () => void;
  handleSubmit: () => void;
  role: string;
  eventName: string;
  fileName: string;
  uploadDone?: boolean; // Claude: show report link after successful upload 27-02-2026
};

const BulkUploadConfirmModal = (props: Props) => {
  return (
    <Box w={"100%"} h={"100%"}>
      <Box
        position={"relative"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        h={"60px"}
        w={"100%"}
      >
        <Image
          onClick={() => {
            props.handleCloseModal();
          }}
          position={"absolute"}
          src={Icons.cross}
          right={0}
          top={0}
        />
      </Box>

      {/* Claude: success state — file received, processing in background 18-05-2026 */}
      {props.uploadDone ? (
        <Box textAlign={"center"} pb={4}>
          <Text fontSize={"md"} fontWeight={"700"} mb={2}>
            Upload submitted!
          </Text>
          <Text fontSize={"sm"} color={"gray.600"} mb={4}>
            <b>{props.fileName}</b> has been received and is being processed in the background.
          </Text>
          <Text fontSize={"xs"} color={"gray.500"} mb={4}>
            Check Upload Reports in a few minutes to see the results.
          </Text>
          <Link
            href="/admin/upload-reports"
            color={"blue.500"}
            fontSize={"sm"}
            fontWeight={500}
            _hover={{ color: "blue.700", textDecoration: "underline" }}
          >
            View Upload Reports →
          </Link>
          <Flex justifyContent={"center"} mt={5}>
            <Button
              size={"sm"}
              fontSize={"xs"}
              px={5}
              bg={"gray.100"}
              color={"gray.600"}
              _hover={{ bg: "gray.200" }}
              onClick={props.handleCloseModal}
            >
              Close
            </Button>
          </Flex>
        </Box>
      ) : (
        <Box>
          <Text fontSize={"md"} textAlign={"center"} fontWeight={"700"}>
            Confirm upload
          </Text>
          {/* Claude: removed eventName from text — uploads are now event-independent; green bg on confirm button 20-02-2026 */}
          <Text fontSize={"sm"} textAlign={"center"}>
            Uploading {props.role} data from {props.fileName}. Proceed ?
          </Text>
          <Flex alignItems={"center"} gap={3} mt={"25px"}>
            <Button
              onClick={() => {
                props.handleSubmit();
              }}
              flex={1}
              size={"md"}
              p={0}
              color={"white"}
              bg={"green.500"}
              fontWeight={500}
              _hover={{ bg: "green.600" }}
            >
              Yes, Upload
            </Button>
            <Button
              flex={1}
              size={"md"}
              p={0}
              bg={"red.100"}
              color={"red.700"}
              _hover={{ bg: "red.600", color: "white" }}
              onClick={() => {
                props.handleCloseModal();
              }}
            >
              No
            </Button>
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default BulkUploadConfirmModal;
